import React from 'react';
import { Layout } from 'antd';
import { ShortcutsProvider } from '../ShortcutsProvider';
import { CommandPalette } from '../ui/CommandPalette';
import { ErrorBoundary } from '../ui/ErrorBoundary';

// <main> lives inside each page-group's <Layout.Content> — not here — so the
// semantic order is <header role=banner>, <nav role=navigation>, <main>,
// rather than <main> swallowing both the header and the sidebar.
export const ComponentMainWrapper = ({ children }) => (
    <Layout className='vh-height'>
        <ShortcutsProvider>
            <ErrorBoundary>{children}</ErrorBoundary>
            <CommandPalette />
        </ShortcutsProvider>
    </Layout>
);
